import React from "react";
import { Row, Col, Tooltip, Glyphicon, OverlayTrigger } from "react-bootstrap";
/* eslint-disable import/no-named-as-default */
import _isEmpty from "lodash/isEmpty";
import ProductLineTabs from "./ProductLineTabs";
/* eslint-enable import/no-named-as-default */
import IntroProductLineTabContent from "./IntroProductLineTabContent";

export default function StartupsDashboard(props) {
  const { productLines } = props;

  const tooltip = (
    <Tooltip id="content-header-tooltip">
      Hier findet ihr eine Übersicht mit allen relevanten Daten zu euren
      registrierten Produktsorten. Es werden nur veröffentlichte Produktsorten
      berücksichtigt.
    </Tooltip>
  );

  return (
    <div className="startups-dashboard">
      <Row>
        <Col md={10} mdPush={1}>
          <span className="content-header">EDEKA StartHub Dashboard </span>
          <OverlayTrigger placement="right" overlay={tooltip}>
            <Glyphicon glyph="info-sign" />
          </OverlayTrigger>
        </Col>
      </Row>

      {_isEmpty(productLines) ? (
        <IntroProductLineTabContent />
      ) : (
        <ProductLineTabs productLines={Object.values(productLines)} />
      )}
    </div>
  );
}
